import React from 'react';
import { View, StyleSheet, ActivityIndicator, Text, Platform } from 'react-native';
import { useSelector } from 'react-redux';
import { selectLoadingState } from '../../store/selectors/mytrips.selector';
import { Color, CommonProperties } from '../../styles';
import { Source } from '../../constants/Enums';

export default function LoadingIndicator() {
  const loadingState = useSelector(selectLoadingState);
  const { isLoading = false, message } = loadingState;
  if (Platform.OS !== Source.IOS || !isLoading) {
    return null;
  }

  return (
    <View style={styles.overlay}>
      <View style={styles.background}>
        <ActivityIndicator size="large" color={'#FFFFFF'} />
        <Text style={styles.text}>{message}</Text>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  overlay: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: Color.shadow,
    ...CommonProperties.centerAlignment,
  },
  background: {
    padding: 20,
    borderRadius: 10,
    alignItems: 'center',
  },
  text: {
    marginTop: 10,
    fontSize: 16,
    color: Color.accent,
  },
});
